<div *ngIf="submenuService.active" class="sub-nav-menu">
    <div class="menu-wrapper">
        <div class="back" (click)="back()"></div>

        <ng-container *ngFor="let item of submenuService.items">

            <ng-container *ngIf="item.type == 'create'">
                <a class="nav-item" [routerLink]="[item.url]" >
                    <p>{{item.title}}</p>
                </a>
            </ng-container>

            <ng-container *ngIf="item.type == 'submit'">
                <a class="nav-item" (click)="submit()" >
                    <p>{{item.title}}</p>
                </a>
            </ng-container>

            <ng-container *ngIf="item.type == 'delete'">
                <a class="nav-item" (click)="delete()" >
                    <p>{{item.title}}</p>
                </a>
            </ng-container>

        </ng-container>
    </div>
</div>